export default __webpack_public_path__ + "static/media/appGallery-fr.b6d3daa4.svg";